<template>
    <div class="the-label">
        <p v-if="text">{{ text }}</p>
        <slot v-else></slot>
    </div>
</template>
<script>
export default {
    props: {
        text: {type: String}
    }
}
</script>
<style scoped>
    .the-label{
        color: #C9C9C9C7;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
    }
</style>